import * as css from './shared.css'
import {CatalogDataGridView, CatalogItemsPanel, GroupByGroupAssortmentCards, GroupByProductsToolbar, InlineAggregateDetails} from '@modules/catalog'
import {useGroupByGroupStore, GroupByGroupChildrenGroups} from './'
import {classNames, React, useHotkeys, observer, useIntersectionObserver, useLayoutEffect, useEffect, pluralize, Fragment} from '@api'
import * as styles from './GroupByGroupContents.css'
import {useStores} from '@design-board'

export const GroupByGroupContents = observer(function GroupByGroupContents() {
  const store = useGroupByGroupStore(),
    {
      hasChildGroup, showEmptyMessage, isExpanded, headerHeight, isFlat, showingInlineAggregationDetails,
      catalog, everExpanded, catalog: {isShowingAssortment, settings: {assortment: {groupingBehavior}}}
    } = store,
    [entry, observerRef] = useIntersectionObserver(),
    everVisible = catalog.isShowingAssortment || store.everVisible || entry.isIntersecting
                  || navigator.platform === 'Win32' // To get around issues in UR on windows where intersection observer isn't working

  useEffect(() => {
    if (everVisible && !store.everVisible) {
      setTimeout(() => store.everVisible = everVisible, 0)
    }
  }, [everVisible])

  // console.log({entry, everVisible})

  // useEffect(() => {
  //   console.log(`Mount GroupByGroupContents`, store?.fullTitle)
  //   return () => console.log(`Unmount GroupByGroupContents`, store?.fullTitle)
  // })

  return (
    !everVisible
    ? !isExpanded ? null
                  : <div ref={observerRef} data-type='never-visible'/>
    : <Fragment>
      {showingInlineAggregationDetails && isExpanded && <InlineAggregateDetails style={{top: isFlat ? `${headerHeight}px` : undefined}}/>}
      {showEmptyMessage
       ? (isFlat ? null : <IntentionallyLeftBlank/>)
       : !everExpanded && (groupingBehavior === 'outside' && !isShowingAssortment || hasChildGroup) ? null :
         hasChildGroup
         ? <GroupByGroupChildrenGroups/>
         : isShowingAssortment && groupingBehavior === 'outside' ? <GroupByGroupAssortmentCards className={css.assortments}/>
                                                                 : <GroupByGroupProductContents/>}
    </Fragment>
  )
})

GroupByGroupContents['whyDidYouRender'] = true
GroupByGroupContents.displayName = 'GroupByGroupContents'

export const IntentionallyLeftBlank = observer<{ className?: string, showText?: boolean }, HTMLDivElement>(function IntentionallyLeftBlank({className, showText}, ref) {
  const {ddEventsNoDragStart} = useGroupByGroupStore() ?? {},
    {strings} = useStores()

  return (
    <div className={classNames(css.products, styles.emptyGroup, className)}
         ref={ref}
         {...(ddEventsNoDragStart ?? {})}>
      {showText && strings.intentionallyBlank}
    </div>
  )
}, {forwardRef: true})

export const GroupByGroupProductContents = observer(function GroupByGroupProductContents() {
  const store = useGroupByGroupStore(),
    {
      isExpanded, everExpanded, onClickProduct, preload, isCard, showCardToolbar, childGroupStore: {path, productQueryVariables}, levelOfDetail,
      onContextMenu, offlineItems,
      props: {level, info: {count, offline_count}}, settings: {fullWidth, singleLine, fullHeight}, ddEventsNoDragStart, hasChildGroup, groupView, queryKey,
      showingAggregateDetails, showingAggregateDetailsinSidebar, contextualHoverItemId, catalog, catalog: {isShowingPresentation, selection, groupBy: {settings: {showExpandedFirst}, isProductView}, settings: {viewMode}}
    } = store,
    visible = isExpanded || isShowingPresentation,
    cardInlineAggregationDetails = isCard && showingAggregateDetails && !showingAggregateDetailsinSidebar

  // useEffect(() => {
  //   console.log(`Mount GroupByGroupProductContents`, store.fullTitle)
  //   return () => console.log(`Unmount GroupByGroupProductContents`, store.fullTitle)
  // })

  return (
    <Fragment>
      {false && isCard && !showExpandedFirst && <div className={styles.catalogItemsLabel}>{pluralize(catalog.catalogItemName)}</div>}
      {isCard && showCardToolbar && <GroupByProductsToolbar className={styles.toolbar}/>}
      {false && cardInlineAggregationDetails && <InlineAggregateDetails className={styles.cardInlineAggregateDetails}/>}
      <div className={classNames(css.products, styles.groupByGroupProductContents)}
           data-type='GroupByGroupProductContents'
           data-visible={visible}
           data-group-view={groupView}
           data-full-width={fullWidth === true}
           data-lod={levelOfDetail}
           data-contextual-hover-item={!!contextualHoverItemId}
           data-full-height={fullHeight || !hasChildGroup}
           data-single-line={singleLine}
           onContextMenu={onContextMenu}
           data-inline-aggregation-details={cardInlineAggregationDetails}
           {...ddEventsNoDragStart}
           onClick={catalog.clearFocusedItem}
           onTouchEnd={(e) => {
             e.stopPropagation()
             selection.clear()
           }}>
        {viewMode === 'table'
         ? <CatalogDataGridView queryVariables={productQueryVariables} offlineItems={offlineItems} />
         : <CatalogItemsPanel
           queryKey={queryKey}
           path={path}
           level={level + 1}
           className={classNames(css.productGroup, styles.productsGroup)}
           data-show-colored-border={groupView === 'flat'}
           queryVariables={productQueryVariables}
           onClickProduct={onClickProduct}
           everVisible={everExpanded || visible}
           preload={preload}
           visible={visible}
           expanded={isExpanded}
           onlineItemCount={count}
           offlineItemCount={offline_count || 0}
           groupStore={store}
         />}
      </div>
    </Fragment>
  )
}, {forwardRef: true})

GroupByGroupProductContents['whyDidYouRender'] = true
GroupByGroupProductContents.displayName = 'GroupByGroupProductContents'


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByGroupContents.tsx